import type * as React from "react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
    icon?: React.ReactNode;
    title: string;
    description?: string;
    action?: React.ReactNode;
    className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps): React.ReactNode {
    return (
        <div className={cn("flex flex-col items-center justify-center rounded-lg border border-dashed py-12 text-center", className)}>
            {icon && <div className="mb-4 text-muted-foreground">{icon}</div>}
            <h3 className="text-sm font-semibold">{title}</h3>
            {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
